import { useContext } from 'react';
import { SubscriptionPaymentContext } from '../SubscriptionPaymentProvider';
export const useSubscriptionPaymentContext = () => {
  const planCheckout = useContext(SubscriptionPaymentContext);
  if (!planCheckout) throw new Error('ServerSideProps context must be use inside ServerSidePropsProvider');
  return planCheckout;
};